export default __webpack_public_path__ + "static/media/male.d7d8ad3d.svg";